import React from 'react'
import Masters_header from './Masters_header'
import { useState, useRef, useEffect } from "react";
import DatePicker from "../DatePicker"
import ReactPaginate from "react-paginate";
import { useNavigate } from 'react-router-dom';
import "../../styles/scope.css";
import JobType_popup from './Jobtype_popup';
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from '../../axiosInstance';
import { usePermissions } from '../../hooks/PermissionContext';
import PermissionWrapper from '../../hooks/PermissionWrapper';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import CommonFooter from '../../CommonFooter/CommonFooter';
import CommonPagination from '../../CommonPagination/CommonPagination';


const JobType = () => {

  let ModuleId = 2
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const popupRef = useRef(null);
  const [editData, setEditData] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteJobTypeId, setDeleteJobTypeId] = useState(null);
  const [bulkConfirmOpen, setBulkConfirmOpen] = useState(false);
  const [bulkDeleteJobTypeId, setBulkDeleteJobTypeId] = useState([]);


  const fetchJobTypes = async (term = '') => {
    try {
      const url = term
        ? `/jobtype/list?search=${term}&limit=${limit}&skip=${skip}`
        : `/jobtype/list?limit=${limit}&skip=${skip}`;

      const response = await axiosInstance.get(url)
      const data = response.data;

      console.log("data.......", data);
      if (Array.isArray(data.category)) {
        console.log("Items received:", data.category.length, data.category);
        setTableData(data.category);
        setTotal(data.totalCount || 0);
        setTotalPages(Math.ceil((data.totalCount || 0) / limit));
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      setError(error.message || "Failed to fetch job types.");
    }
  };

  useEffect(() => {
    fetchJobTypes(searchTerm);
  }, [skip, limit]);



  const postJobType = async (formData) => {
    try {
      const response = await axiosInstance.post('/jobtype/save', formData);

      toast.success('Job type created successfully!');
      setTimeout(() => {
        fetchJobTypes();
      }, 800);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Something went wrong!";
      toast.error(errorMessage);
      console.error("Error creating job type:", error);
      throw error;
    }
  };

  const putJobType = async (id, formData) => {
    try {
      const payload = {
        id: formData.id,
        ...formData,
      };

      const response = await axiosInstance.put('/jobtype/update', payload);

      toast.success('Job type updated successfully!');
      setTimeout(() => {
        fetchJobTypes();
      }, 800);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Something went wrong!";
      toast.error(errorMessage);
      console.error("Error updating job type:", error);
      throw error;
    }
  };



  const saveJobType = async (formData) => {
    try {
      if (editData) {
        await putJobType(editData.id, formData);
      } else {
        await postJobType(formData);
      }
      setTimeout(() => {
        closePopup();
      }, 800);
    } catch (error) {
      console.error("Save operation failed:", {
        error: error.toString(),
        formData,
        isEdit: !!editData
      });
      alert(`Operation failed: ${error.message}`);
    }
  };



  // const fetchJobTypeForEdit = async (id) => {
  //   try {
  //     // const response = await fetch(`${API_BASE_URL}/jobtype/edit/${id}`);
  //     const response = await fetch(
  //       `/jobtype/edit/${id}`
  //     );
  //     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

  //     const data = await response.json();
  //     setEditData(data.jobtype);
  //     setIsPopupOpen(true);
  //   } catch (error) {
  //     console.error("Error fetching charge code:", error);
  //     alert(`Failed to load charge code for editing: ${error.message}`);
  //   }
  // };

  const fetchJobTypeForEdit = async (id) => {
    try {
      const response = await axiosInstance.get(`/jobtype/edit/${id}`);
      const data = response.data;

      setEditData(data.jobtype);
      setIsPopupOpen(true);
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      console.error("Error fetching job type:", error);
      alert(`Failed to load job type for editing: ${errorMessage}`);
    }
  };



  const bulkdeleteJobType = (ids) => {
    if (ids.length === 0) {
      toast.warning("Please select at least one job type to delete.");
      return;
    }

    // Open confirmation dialog
    setBulkDeleteJobTypeId(ids);
    setBulkConfirmOpen(true);
  };

  // Confirm handler
  const confirmBulkDeleteJobTypes = async () => {
    if (bulkDeleteJobTypeId.length === 0) return;

    try {
      await axiosInstance.delete('/jobtype/bulk_delete', {
        data: { ids: bulkDeleteJobTypeId }
      });

      toast.success(`${bulkDeleteJobTypeId.length} job type(s) deleted successfully!`);
      fetchJobTypes(); // Refresh the list
      setSelectedRows([]); // Clear selection
    } catch (error) {
      console.error("Error deleting job types:", error);
      const errorMessage = error.response?.data?.message || "Something went wrong while deleting!";
      toast.error(errorMessage);
    } finally {
      setBulkConfirmOpen(false);
      setBulkDeleteJobTypeId([]);
    }
  };

  // Cancel handler
  const cancelBulkDeleteJobTypes = () => {
    setBulkConfirmOpen(false);
    setBulkDeleteJobTypeId([]);
  };


  const handleDeleteClick = (id) => {
    setDeleteJobTypeId(id);
    setDeleteConfirmOpen(true);
  };


  const confirmDeleteJobType = async () => {
    if (!deleteJobTypeId) return;

    try {
      await axiosInstance.delete(`/jobtype/delete/${deleteJobTypeId}`);
      toast.success("Job type deleted successfully!");
      fetchJobTypes();
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      console.error("Error:", error);
      toast.error(`Failed to delete job type! ${errorMessage}`);
    } finally {
      setDeleteConfirmOpen(false);
      setDeleteJobTypeId(null);
    }
  };

  const cancelDeleteJobType = () => {
    setDeleteConfirmOpen(false);
    setDeleteJobTypeId(null);
  };


  // useEffect(() => {
  //   fetch()
  //     .then((response) => {
  //       if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  //       return response.json();
  //     })
  //     .then((data) => {
  //       if (Array.isArray(data.scopes)) {
  //         setTableData(data.scopes);
  //         setTotal(data.totalCount || 0);
  //         setTotalPages(Math.ceil((data.totalCount || 0) / limit));
  //       } else {
  //         setTableData([]);
  //       }
  //     })
  //     .catch((error) => {
  //       setError(error.message);
  //       console.error("There was a problem with the fetch operation:", error);
  //     });
  // }, [skip, limit]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const handlePageClick = ({ selected }) => {
    console.log("Page clicked:", selected);
    setCurrentPage(selected);
    setSkip(selected * limit);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0); // Reset skip when limit changes
  };


  const handleDateSelection = (date) => {
    console.log("Selected Date:", date);
  };


  const handleAddNewClick = () => setIsPopupOpen(true);


  const closePopup = () => {
    setEditData(null);
    setIsPopupOpen(false);
  };


  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;

  const handleSelectAll = () => {
    if (selectedRows.length === tableData.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(tableData.map(jobtype => jobtype.id));
    }
  };

  const handleRowSelect = (id) => {
    setSelectedRows(prev =>
      prev.includes(id)
        ? prev.filter(rowId => rowId !== id)
        : [...prev, id]
    );
  };

  const handleEditClick = (id) => {
    fetchJobTypeForEdit(id);
  };

  const handleSearch = async (term) => {
    setSearchTerm(term);
    setSkip(0);
    await fetchJobTypes(term);
  };


  return (
    <>
      <Masters_header onSearch={handleSearch} />
      <div className="container">
        <div className="header">
          <div className="left-header">
            <h3>Job Type: {total}</h3>
          </div>
          <div className="right-header">

            {isAnySelected ? (
              <button id="deleteBtn"
                className="deleteBtn"
                style={{ cursor: 'pointer', margin: '0px' }}
                onClick={() => bulkdeleteJobType(selectedRows)}
              >
                Delete
              </button>

            ) : (
              <>


                <PermissionWrapper permissionKey="create_permission" moduleId={ModuleId}>
                  {!isAnySelected && (
                    <button id="addNewBtn" onClick={handleAddNewClick}>
                      Add New
                    </button>
                  )}
                </PermissionWrapper>
              </>
            )}

          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th style={{
                width: "60px",
                minWidth: "60px",
                textAlign: "center",
                padding: "4px",
                cursor: 'pointer'
              }}>
                <input type="checkbox"
                  checked={isAllSelected}
                  onChange={handleSelectAll} />
              </th>
              <th >Code</th>
              <th>Name</th>
              <th>Division</th>
              <th>Modified Date</th>
  
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((jobtype, index) => (
              <tr key={index}>
                <td style={{
                  width: "60px",
                  minWidth: "60px",
                  textAlign: "center",
                  padding: "4px",
                  cursor: 'pointer'
                }}>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(jobtype.id)}
                    onChange={() => handleRowSelect(jobtype.id)}
                  />
                </td>

                <td className="table-cell"> {jobtype.job_type_code}</td>
                <td >{jobtype.job_type_name}</td>
                <td>{jobtype.job_type_division.toUpperCase()}</td>
                <td >{jobtype.modifieddate}</td>
                <td>
                  <div className="actions">

                    <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                      <span
                        className="edit-icon"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleEditClick(jobtype.id)}

                      >
                        <img src={Vector} alt="Edit Icon" width="20" height="20" />
                      </span>
                    </PermissionWrapper>


                    <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                      <span className="delete-icon"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleDeleteClick(jobtype.id)}
                      >
                        <img src={Delete} alt="Delete Icon" width="40" height="40" />
                      </span>
                    </PermissionWrapper>

                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {searchTerm && tableData.length === 0 && (
          <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
            No JobType found matching "{searchTerm}"
          </div>
        )}

        <CommonPagination
          currentPage={currentPage}
          totalPages={totalPages > 0 ? totalPages : 1}
          limit={limit}
          onPageChange={handlePageClick}
          onLimitChange={handleLimitChange}
        />
      </div>
      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content" ref={popupRef}>
            <JobType_popup
              closePopup={closePopup}
              onSubmit={saveJobType}
              editData={editData} />
          </div>
        </div>
      )}
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <ConfirmDialog
        open={deleteConfirmOpen}
        title="Delete Job Type"
        message="Are you sure you want to delete this job type?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDeleteJobType}
        onCancel={cancelDeleteJobType}
      />
      <ConfirmDialog
        open={bulkConfirmOpen}
        title="Bulk Delete"
        message={`Are you sure you want to delete ${bulkDeleteJobTypeId.length} job type(s)?`}
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmBulkDeleteJobTypes}
        onCancel={cancelBulkDeleteJobTypes}
      />

    </>
  )
}

export default JobType